module.exports = __webpack_public_path__ + "static/media/open-gallery.a6788abf.svg";